import { render, staticRenderFns } from "./comentarios.vue?vue&type=template&id=825a109c&scoped=true"
import script from "./comentarios.vue?vue&type=script&lang=js"
export * from "./comentarios.vue?vue&type=script&lang=js"
import style0 from "./comentarios.vue?vue&type=style&index=0&id=825a109c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825a109c",
  null
  
)

export default component.exports